import React, { Component } from 'react'
import Axios from 'axios'
import Logo from '../Img/logo.png';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Parse from 'html-react-parser';

var JsBarcode = require('jsbarcode')
class PrinterPageSerie extends React.Component {
  //add new printer
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      allCartelas: [],
      serie: null,
      captura: "",
      id: "",
      nSerie: localStorage.getItem("nSerie"),
      parametros: null
    }
    this.CapturaParametrosUrl()
    this.printar = this.printar.bind(this)
    this.getParametros()




  }
  componentDidMount() {
    // setTimeout(this.printarPagina, 4000)
    let count = 0;
    let interval = setInterval(async function(){
        if(count >= 2){
          clearInterval(interval);
          window.print()
        }
        count +=1;
    },1000)
  }


  async getParametros() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.get('parametros/get-premios')
      this.setState({ parametros: response.data })
    } catch (err) {
      console.log(err)
    }
  }


  async getTodosPedidos() {
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem("apiUrl")
      });
      const response = await axiosInstance.get("pedidos/listar-2", {});
      this.setState({ allCartelas: this.splitArrayCartelas(response.data.reverse()) });
      if (this.state.serie != null) {
        this.removerCartelaSerie()
      }
    } catch (err) {
      console.log(err);
    }
  }

  splitArrayCartelas(array) {
    var arrayCartelas = []
    array.map(element => {
      element.cartelas.map(cartela => {
        arrayCartelas.push(cartela)
      })

    })

    return arrayCartelas;
  }

  removerCartelaSerie() {

    this.state.allCartelas.map(cartela => {
      this.state.serie.cartelas.map((sCartela, index) => {
        if (sCartela.codigo == cartela.codigo) {
          this.state.serie.cartelas.splice(index, 1)
        }
      })
    })

    this.setState({ serie: this.state.serie })
    this.gerarCodigo()
    //   this.printarPagina()
  }





  printarPagina() {
    window.print()
  }

  CapturaParametrosUrl() {

    //captura a url da página
    var url = window.location.href;

    //tenta localizar o ?
    var res = url.split('?');

    if (res[1] === undefined) {
      alert('página sem parâmetros.');
    }

    if (res[1] !== undefined) {
      //tenta localizar os & (pode haver mais de 1)
      var parametros = res[1].split('&');

      //qtd. de parâmetros que serão tratados pelo laço.
      var qtdParametrosParaLer = 5;

      //guarda o nome dos parâmetros e os valores e, vetores.
      var parametroEncontrado = new Array();
      var valorParametro = new Array();

      for (var cont = 0; cont <= qtdParametrosParaLer; cont++) {
        if (parametros[cont] !== undefined) {
          this.setState({ captura: parametros[cont].split('=') })
          this.state.captura = parametros[cont].split('=');
          this.setState({ id: this.state.captura[1].toString() });
          this.state.id = this.state.captura[1].toString();


          parametroEncontrado[cont] = this.state.captura[0];
          valorParametro[cont] = this.state.captura[1];
          this.getSerie()
        }
      }
    }
  }

  async getSerie(){
    var _id = "" +  this.state.id.toString()
    try {
      var axiosInstance = new Axios.create({
        baseURL: window.localStorage.getItem('apiUrl')
      })
      const response = await axiosInstance.post("series/id", {id: _id})
      this.setState({ serie: response.data })
      window.localStorage.setItem('printItem', JSON.stringify(response.data))
      
      this.getTodosPedidos()


    } catch (err) {
      console.log(err)
    }
  }

  printar() {
    // window.location.to="gonative://share/sharePage"
    window.print()
  }

  formatDate(data) {
    return moment(data).add(0, 'days').format('DD-MM-YYYY')
  }


  gerarCodigo() {

    this.state.serie.cartelas.map(cartela => {
      JsBarcode("#aaaa" + cartela.codigo, cartela.codigo)
    })
    this.printarPagina()

  }

  render() {

    return <div >
      {/* <div className="w-100 p-2"><button className="w-100 btn-fill btn btn-danger" onClick={this.printar}><i className="fas fa-print"></i></button></div> */}
      {this.state.serie ?
        this.state.serie.cartelas.map((cartela, index) => {

          return (

            <div class='mb-1' >
              <div className="text-center justify-content-center">
                {/* <div class='row justify-content-center'><h1 className="barcode">{cartela.codigo}</h1></div> */}
                <div class='d-flex justify-content-center'><img style={{ maxWidth: "40%", minWidth: "40%" }} src={Logo} /></div>
                <div class='d-flex justify-content-center text-center'><span className="font-weight-bold text-dark" style={{fontSize: '12px'}} >SORTEIO - {this.formatDate(this.state.serie.cartelas[0].data)} - {this.state.serie.cartelas[0].horario ? this.state.serie.cartelas[0].horario : '10:00'} </span></div>
                <div className="border-bottom"><span className="font-weight-bold" style={{fontSize: '12px'}} >Cartela: {cartela.codigo} Serie : {this.state.nSerie}</span></div>
              </div>
              <div className="d-flex pl-3 m-0" style={{alignItems: "center", height: '20px', marginTop: "-2px"}}><span className="font-weight-bold" style={{ margin: '0', fontSize: '12px'  }}>Nome:</span><hr style={{ borderBottom: '1px solid black', borderRadius: '2px', minWidth: '80%', marginLeft: '2px' }}></hr></div>
              <div className="d-flex pl-3 m-0" style={{alignItems: "center", height: '20px'}}><span className="font-weight-bold" style={{ margin: '0', fontSize: '12px'  }}>Contato:</span><hr style={{ borderBottom: '1px solid black', borderRadius: '2px', minWidth: '74%', marginLeft: '2px' }}></hr></div>
              <div className="d-flex pl-3 m-0" style={{alignItems: "center", height: '20px'}}><span className="font-weight-bold" style={{ margin: '0', fontSize: '12px'  }}>Endereço:</span><hr style={{ borderBottom: '1px solid black', borderRadius: '2px', minWidth: '72%', marginLeft: '2px' }}></hr></div>
              {/* <div className="d-flex pl-3 m-0" ><span className="font-weight-bold" style={{ margin: '0', fontSize: '12px'  }}></span><hr style={{ borderBottom: '1px solid black', borderRadius: '2px', minWidth: '100%', marginLeft: '2px' }}></hr></div> */}
              <div className="d-flex pl-3 m-0" ><span className="font-weight-bold" style={{ margin: '0', fontSize: '10px'  }}>Vd: {this.state.serie.cambistaId.nome}</span></div>
              <div className="d-flex pl-3 m-0" ><span className="font-weight-bold" style={{ margin: '0', fontSize: '10px' }}>matriz: {cartela.numeros.join(",")}</span></div>
              {/* <div class='row justify-content-center'><svg style={{maxHeight: '5em !important'}} id={"aaaa" + cartela.codigo}></svg></div> */}
              <hr style={{ borderBottom: '2px dotted black', borderRadius: '2px', minWidth: '100%', marginTop: "0" }}></hr>

              <div class='d-flex justify-content-center'><img style={{ maxWidth: "40%", minWidth: "40%", marginTop: "-10px" }} src={Logo} /></div>
              {/* <div class='row rounded bg-dark text-light text-center justify-content-center '><h5 className="font-weight-bold" style={{ margin: '0' }}><span><i className="fa fa-youtube-play mr-3" aria-hidden="true"></i>LIVE NO YOUTUBE</span></h5></div> */}
              <div class='d-flex justify-content-center text-center '><span className="font-weight-bold text-dark" >SORTEIO - {this.formatDate(this.state.serie.cartelas[0].data)} - {this.state.serie.cartelas[0].horario ? this.state.serie.cartelas[0].horario : '10:00'} </span></div>



              <div className="text-dark  w-100 text-center" style={{ display: 'flex', flexDirection: 'column', fontSize: "10px !important", fontWeight: 'bolder !important' }}>
                {Parse(this.state.parametros? this.state.parametros.premios : "")}
              </div>
              <div class='d-flex  justify-content-center text-center ' style={{ fontSize: '10px' }}><span className="ml-3 font-weight-bold" >Sº: {this.state.nSerie} / vd: {this.state.serie.cambistaId.nome}</span> </div>
              <div class='d-flex  justify-content-center text-center ' style={{ fontSize: '10px' }}><span className="ml-3 font-weight-bold" >{this.state.user.nome}</span> </div>
              <div
                className="mb-1 w-100 rounded"


              >

                <div className="container text-dark border border-dark">
                  <div className="row pt-2 border border-dark text-center justify-content-center" >
                    <h6 class='text-center '><span className="font-weight-bold" style={{ fontSize: '1em' }}>R$: {cartela.valor} -  Cartela: {cartela.codigo}</span></h6>
                  </div>
                  <div className="row border border-dark">
                    <div class='col border border-dark text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[0]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[1]}</span>
                    </div>
                    <div class='col border border-dark text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[2]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[3]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[4]}</span>
                    </div>
                  </div>
                  <div className="row border border-dark">
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[5]}</span>
                    </div>
                    <div class='col border  border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[6]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[7]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[8]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[9]}</span>
                    </div>
                  </div>
                  <div className="row border border-dark">
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[10]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[11]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[12]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[13]}</span>
                    </div>
                    <div class='col border border-dark  text-dark font-weight-bold text-center p-2' style={{ minHeight: '3em', maxHeight: '3em' }}>
                      <span className="p2" style={{ fontSize: '1.2em' }}>{cartela.numeros[14]}</span>
                    </div>
                  </div>
                </div>
              </div>
              <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
            </div>


          )
        }) : ""}
    </div>

  }
}

export default PrinterPageSerie;